import { Link } from "react-router-dom";
import { ArrowRight } from "lucide-react";
import Seo from "@/components/Seo";

export default function NotFound() {
  return (
    <>
      <Seo title="Page Not Found" description="The page you're looking for doesn't exist." path="/404" />
      <section className="flex min-h-[60vh] items-center bg-platinum py-24" data-testid="not-found">
        <div className="mx-auto max-w-2xl px-4 text-center sm:px-6">
          <p className="font-display text-xs font-bold uppercase tracking-[0.25em] text-cobalt">404</p>
          <h1 className="mt-4 font-display text-3xl font-bold tracking-tight text-ink sm:text-4xl">
            This destination isn't on the map.
          </h1>
          <p className="mt-4 text-ink/70">
            The page you're looking for doesn't exist — but seven real opportunities do.
          </p>
          <div className="mt-8 flex flex-col items-center justify-center gap-3 sm:flex-row">
            <Link
              to="/"
              data-testid="notfound-home-link"
              className="inline-flex items-center gap-2 rounded-md bg-cobalt px-6 py-3 font-display text-sm font-semibold text-white transition-colors hover:bg-midnight"
            >
              Back to Home
              <ArrowRight className="h-4 w-4" />
            </Link>
            <Link
              to="/solutions"
              data-testid="notfound-solutions-link"
              className="inline-flex items-center gap-2 rounded-md border border-ink/20 bg-white px-6 py-3 font-display text-sm font-semibold text-ink transition-colors hover:border-cobalt hover:text-cobalt"
            >
              Explore the Solutions
            </Link>
          </div>
        </div>
      </section>
    </>
  );
}
